var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",class:_vm.inputClass,on:{"change":function($event){return _vm.emitChange($event)}}},[_c('option',{attrs:{"value":"-1"}},[_vm._v("Select Template")]),_vm._l((_vm.mailTemplates),function(t,index){return _c('option',{key:index,domProps:{"value":t.id}},[_vm._v(" "+_vm._s(t.name)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }